"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

var _openingHours = require("./openingHours");

function locationToPostalAddress(location) {
  var hours = null;
  var openedHours = location.hours.filter(function (_ref) {
    var open = _ref.open,
        close = _ref.close;
    return !!open && !!close;
  });
  var isOpenSomeDay = openedHours.length > 0;

  if (isOpenSomeDay) {
    hours = (0, _openingHours.getOpeningHoursSpecification)(openedHours);
  }

  return {
    "@type": "PostalAddress",
    addressLocality: location.city,
    addressRegion: location.state,
    streetAddress: location.street,
    email: location.email,
    telephone: location.phoneNumber,
    name: location.name,
    hoursAvailable: hours
  };
}

var _default = function _default(address) {
  var onlyPrimary = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!address) {
    return null;
  }

  if (typeof address === 'string') {
    return address;
  }

  if ((0, _isArray2["default"])(address)) {
    if (onlyPrimary) {
      return locationToPostalAddress(address[0]);
    }

    return address.map(locationToPostalAddress);
  }

  return locationToPostalAddress(address);
};

exports["default"] = _default;